export default __webpack_public_path__ + "static/media/huaca.43dae559.png";